import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 pt-16">
        <span className="text-8xl font-heading font-bold text-primary-200">404</span>
        <h1 className="text-xl font-heading font-semibold text-foreground-900 mt-6 mb-3">
          页面未找到
        </h1>
        <p className="text-sm text-foreground-500 mb-8 max-w-md">
          你访问的页面可能已被移除、名称已更改或暂时不可用。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
      <Footer />
    </>
  );
}